export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-app text-primary-fg px-5 md:px-10 py-12">
      <div className="max-w-3xl mx-auto">
        <a href="/" className="text-sm text-tertiary-fg hover:text-primary-fg">← Torna alla home</a>
        <h1 className="font-display text-4xl font-semibold tracking-tight mt-6 mb-2">Termini di Servizio</h1>
        <p className="text-tertiary-fg text-sm">Ultimo aggiornamento: Febbraio 2026</p>

        <div className="prose prose-invert mt-8 space-y-6 text-secondary-fg">
          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">1. Accettazione dei termini</h2>
            <p>Utilizzando Family Brain (&ldquo;il Servizio&rdquo;) accetti questi Termini di Servizio. Se non accetti questi termini, non utilizzare il Servizio.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">2. Descrizione del servizio</h2>
            <p>Family Brain è una piattaforma SaaS che permette alle famiglie di organizzare digitalmente documenti, scadenze, eventi e comunicazioni con l&apos;aiuto dell&apos;intelligenza artificiale.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">3. Account utente</h2>
            <p>Sei responsabile della sicurezza del tuo account e di tutte le attività che vi vengono svolte. Devi avere almeno 18 anni per creare un account. Per minori, è necessario il consenso del genitore o tutore legale.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">4. Piani e pagamenti</h2>
            <p>Family Brain offre piani <strong>Free</strong>, <strong>Standard (€4.99/mese o €49/anno)</strong> e <strong>Premium (€15.99/mese o €159/anno)</strong>. I pagamenti sono elaborati da Stripe e sono non rimborsabili salvo quanto previsto dalla legge italiana sul recesso (14 giorni).</p>
            <p>Ogni nuovo account riceve automaticamente 7 giorni di Premium gratuito senza obbligo di carta.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">5. Contenuti dell&apos;utente</h2>
            <p>Resti il proprietario di tutti i contenuti che carichi (documenti, foto, messaggi). Concedendoci una licenza limitata, autorizzi Family Brain a processarli per fornirti il Servizio (classificazione AI, ricerca, archiviazione).</p>
            <p>Non caricare contenuti illegali, offensivi, o che violano diritti di terzi.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">6. Intelligenza artificiale</h2>
            <p>L&apos;AI fornita (basata su modelli GPT) elabora i tuoi dati per offrire risposte e suggerimenti. Le risposte AI possono contenere imprecisioni. Non usare l&apos;AI per consigli medici, legali, finanziari o decisioni critiche senza verifica indipendente.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">7. Limitazione di responsabilità</h2>
            <p>Family Brain è fornito &ldquo;così com&apos;è&rdquo;. Non garantiamo la disponibilità continua, l&apos;assenza di errori, o la perdita di dati. Eseguiamo backup ma raccomandiamo di mantenere copie di documenti critici altrove.</p>
            <p>La nostra responsabilità complessiva non potrà superare l&apos;importo pagato dall&apos;utente nei 12 mesi precedenti l&apos;evento.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">8. Cancellazione account</h2>
            <p>Puoi cancellare il tuo account in qualsiasi momento dalle Impostazioni. La cancellazione elimina definitivamente tutti i tuoi dati entro 30 giorni.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">9. Modifiche ai termini</h2>
            <p>Ci riserviamo il diritto di aggiornare questi termini. Le modifiche saranno comunicate via email o nell&apos;app almeno 30 giorni prima dell&apos;entrata in vigore.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">10. Legge applicabile e foro competente</h2>
            <p>Questi termini sono regolati dalla legge italiana. Foro competente esclusivo: tribunale del luogo di residenza del titolare.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-primary-fg font-medium">11. Contatti</h2>
            <p>Per domande: <a href="mailto:info@familybrain.it" className="text-brand">info@familybrain.it</a></p>
          </section>

          <p className="text-xs text-tertiary-fg pt-8 border-t border-subtle">
            ⚠️ Questo documento è un template di base. Per uso commerciale ti consigliamo di personalizzarlo con un legale o usare servizi tipo Iubenda.
          </p>
        </div>
      </div>
    </div>
  );
}
